import React from "react";
import { Route, Routes } from "react-router-dom";
import { RequireAuth } from "./RequireAuth";
import { RoutePaths } from "./routePaths";
import { HomeView } from "../../views/Home"
import { LoginView, LoginPasswordView, SetNewPasswordView } from "../../views/Login";
import { SessionExpiredView } from "../../views/Login/SessionExpiredView";
import { SignupView, SignupConfirmView } from "../../views/SignUp";
import { LicenseeListView, LicenseeAEView } from "../../views/Licensee";
import { BrokerListView, BrokerAEView } from "../../views/Brokers";
import { PafListView, PafAEView, PafApplicationView, PafSignView } from "../../views/Pafs";
import { CompanyListView, CompanyAEView } from "../../views/client";
import { UserListView, UserAEView } from "../../views/Users";
import { AccountSettingsView } from "../../views/AccountSettings";
import {
    ContactUs, NotFound, Privacy,
    Security, Status, TermsOfUse, Unauthorized
} from "../../views/_static";

import { AuthRolesEnum } from "../../_appData";
import { PasswordResetView } from "../../views/PasswordReset/PasswordResetView";
import { PasswordResetConfirmView } from "../../views/PasswordReset/PasswordResetConfirmView";

export const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/"
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.BrokerAgent, AuthRolesEnum.ListAdmin,
                    AuthRolesEnum.ListOwner, AuthRolesEnum.Licensee, AuthRolesEnum.PafUser,
                    AuthRolesEnum.PafAdmin, AuthRolesEnum.UserAdmin, AuthRolesEnum.SystemAdmin]}>
                        <HomeView />
                    </RequireAuth>
                }
            />
            <Route path="/Licensees"
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.SystemAdmin,
                    AuthRolesEnum.Licensee,]}>
                        <LicenseeListView />
                    </RequireAuth>
                }
            />
            <Route path="/Licensee/:id"
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.SystemAdmin,
                    AuthRolesEnum.Licensee,]}>
                        <LicenseeAEView />
                    </RequireAuth>
                }
            />
            <Route path="/Brokers"
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.SystemAdmin, AuthRolesEnum.BrokerAgent,
                    AuthRolesEnum.ListAdmin, AuthRolesEnum.ListOwner, AuthRolesEnum.Licensee,]}>
                        <BrokerListView />
                    </RequireAuth>
                }
            />
            <Route path="/ListAdmins"
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.SystemAdmin, AuthRolesEnum.BrokerAgent,
                    AuthRolesEnum.ListAdmin, AuthRolesEnum.ListOwner, AuthRolesEnum.Licensee,]}>
                        <BrokerListView />
                    </RequireAuth>
                }
            />
            <Route path="/Broker/:id"
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.SystemAdmin, AuthRolesEnum.BrokerAgent,
                    AuthRolesEnum.ListAdmin, AuthRolesEnum.ListOwner, AuthRolesEnum.Licensee]}>
                        <BrokerAEView />
                    </RequireAuth>
                }
            />
            <Route path="/ListAdmin/:id"
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.SystemAdmin, AuthRolesEnum.BrokerAgent,
                    AuthRolesEnum.ListAdmin, AuthRolesEnum.ListOwner, AuthRolesEnum.Licensee]}>
                        <BrokerAEView />
                    </RequireAuth>
                }
            />
            <Route path="/Pafs"
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.BrokerAgent, AuthRolesEnum.ListAdmin,
                    AuthRolesEnum.ListOwner, AuthRolesEnum.Licensee, AuthRolesEnum.SystemAdmin]}>
                        <PafListView />
                    </RequireAuth>
                }
            />
            <Route path="/Paf/:id"
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.BrokerAgent, AuthRolesEnum.ListAdmin,
                    AuthRolesEnum.ListOwner, AuthRolesEnum.Licensee, AuthRolesEnum.SystemAdmin]}>
                        <PafAEView />
                    </RequireAuth>
                }
            />
            <Route path="/Companies"
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.BrokerAgent, AuthRolesEnum.ListAdmin,
                    AuthRolesEnum.ListOwner, AuthRolesEnum.Licensee, AuthRolesEnum.SystemAdmin,
                    AuthRolesEnum.PafUser, AuthRolesEnum.PafAdmin]}>
                        <CompanyListView />
                    </RequireAuth>
                }
            />
            {/* First-time company creation: nav hidden until form submitted; explicit path for refresh/direct URL */}
            <Route path={RoutePaths.COMPANY_REGISTER}
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.BrokerAgent, AuthRolesEnum.ListAdmin,
                    AuthRolesEnum.ListOwner, AuthRolesEnum.Licensee, AuthRolesEnum.SystemAdmin,
                    AuthRolesEnum.PafUser, AuthRolesEnum.PafAdmin]}>
                        <CompanyAEView />
                    </RequireAuth>
                }
            />
            <Route path="/Company/:id"
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.BrokerAgent, AuthRolesEnum.ListAdmin,
                    AuthRolesEnum.ListOwner, AuthRolesEnum.Licensee, AuthRolesEnum.SystemAdmin,
                    AuthRolesEnum.PafUser, AuthRolesEnum.PafAdmin]}>
                        <CompanyAEView />
                    </RequireAuth>
                }
            />
            <Route path="/PafApplication"
                element={
                    <RequireAuth authRoles={[ AuthRolesEnum.ListAdmin,
                    AuthRolesEnum.ListOwner, AuthRolesEnum.Licensee]}>
                        <PafApplicationView />
                    </RequireAuth>
                }
            />
            <Route path="/Users"
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.BrokerAgent, AuthRolesEnum.ListAdmin,
                    AuthRolesEnum.ListOwner, AuthRolesEnum.SystemAdmin, AuthRolesEnum.Licensee]}>
                        <UserListView />
                    </RequireAuth>
                }
            />
            <Route path="/User/:id"
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.BrokerAgent, AuthRolesEnum.ListAdmin,
                    AuthRolesEnum.ListOwner, AuthRolesEnum.SystemAdmin, AuthRolesEnum.Licensee]}>
                        <UserAEView />
                    </RequireAuth>
                }
            />
            <Route path="/account-settings"
                element={
                    <RequireAuth authRoles={[AuthRolesEnum.BrokerAgent, AuthRolesEnum.ListAdmin,
                    AuthRolesEnum.ListOwner, AuthRolesEnum.Licensee, AuthRolesEnum.PafUser,
                    AuthRolesEnum.PafAdmin, AuthRolesEnum.UserAdmin, AuthRolesEnum.SystemAdmin]}>
                        <AccountSettingsView />
                    </RequireAuth>
                }
            />

            <Route path="/login" element={<LoginPasswordView />} />
            <Route path="/set-new-password" element={<SetNewPasswordView />} />
            <Route path="/session-expired" element={<SessionExpiredView />} />
            <Route path="/signup" element={<SignupView />} />
            <Route path="/signup-confirm" element={<SignupConfirmView />} />
            <Route path="/password-reset" element={<PasswordResetView />} />
            <Route path="/password-reset-confirm" element={<PasswordResetConfirmView />} />

            {/* Presigned PAF Sign route (no authentication required) */}
            <Route path="/paf-sign/:token" element={<PafSignView />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/security" element={<Security />} />
            <Route path="/status" element={<Status />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/unauthorized" element={<Unauthorized />} />

            {/* Finally, catch all unmatched routes */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}
